// Los conteos ausentes no equivalen a cero; 0/0 sí es una proporción válida.
export function formatReportRatio(numerator, denominator, format = String) {
  if (numerator == null || denominator == null) return '—'
  return `${format(numerator)}/${format(denominator)}`
}
